import { Component, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, Event as RouterEvent } from '@angular/router';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { AppService } from './app.service';
import { LayoutService } from './layout/layout.service';
import { LoadingOverlayService } from './loading-overlay/loading-overlay.service';

@UntilDestroy()
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styles: [':host { display: block; }'],
    standalone: false
})
export class AppComponent {
    private readonly router = inject(Router);
    private readonly appService = inject(AppService);
    private readonly layoutService = inject(LayoutService);
    readonly loadingOverlayService = inject(LoadingOverlayService);

    public constructor() {
        // Subscribe to router events to handle page transition
        this.router.events //
            .pipe(untilDestroyed(this))
            .subscribe(this.navigationInterceptor.bind(this));

        // Disable animations and transitions in IE10 to increase performance
        if (typeof (document as any).documentMode === 'number' && (document as any).documentMode < 11) {
            const style = document.createElement('style');
            style.textContent = `
                * {
                  -ms-animation: none !important;
                  animation: none !important;
                  -ms-transition: none !important;
                  transition: none !important;
                }`;
            document.head.appendChild(style);
        }
    }

    private navigationInterceptor(e: RouterEvent) {
        if (e instanceof NavigationStart) {
            // Set loading state
            document.body.classList.add('app-loading');
        }

        if (e instanceof NavigationEnd) {
            // Scroll to top of the page
            this.appService.scrollTop(0, 0);
        }

        if (e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError) {
            // On small screens collapse sidenav
            if (this.layoutService.isSmallScreen() && !this.layoutService.isCollapsed()) {
                setTimeout(() => this.layoutService.setCollapsed(true, true), 10);
            }

            // Remove loading state
            document.body.classList.remove('app-loading');
            // Remove initial splash screen !!! INITIAL (index.html)
            const splashScreen = document.querySelector('.init-loading-overlay');
            if (splashScreen) {
                (splashScreen as any).style.opacity = 0;
                setTimeout(() => splashScreen && splashScreen.parentNode && splashScreen.parentNode.removeChild(splashScreen), 300);
            }

            // Remove of forgotten LoadingScreens, not initial splash screen
            //this.loadingOverlayService.stopLoading();
        }
    }
}
